'use client';

import { cn } from '@/app/lib';
import { ClearRefinements, ClearRefinementsProps } from './ClearRefinements';
import { textButtonVariants } from '@workspace/ui/common';

type AlgoliaClearRefinementsProps = ClearRefinementsProps & {
  disableButtonClass?: string;
};
const textButtonClasses = textButtonVariants();

export function AlgoliaClearRefinements({ disableButtonClass, ...props }: AlgoliaClearRefinementsProps) {
  return (
    <ClearRefinements
      className="pt-sm md:pt-md flex justify-center"
      classNames={{
        button: cn(textButtonClasses, 'underline leading-tight'),
        disabledButton: cn(disableButtonClass, '!invisible'),
      }}
      translations={{
        resetButtonText: 'Clear all filters',
      }}
      excludedAttributes={[]}
      {...props}
    />
  );
}
